import React from 'react'
import { Toaster } from 'sonner'

export default function ToastContainer() {
  return (
    <Toaster
      toastOptions={{
        className: '',
      }}
      position='bottom-right'
      closeButton
      visibleToasts={5}
    />
  )
}
